import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Typography, Button, Menu, MenuItem } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { IconButton, Tooltip, Snackbar, Switch, Checkbox } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const permission = {
  0: 'Edit Calendar',
  1: 'Edit User',
  2: 'Admin'
}
// Modern Dark Theme with Slight Adjustments
const modernDarkTheme = createTheme({
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: '#ebebeb', // Light blue background (lighter than the previous one)
          borderRadius: '10px', // Rounded corners
          border: '1px solid #444', // Subtle border for contrast
          color: '#333', // Darker font for contrast
        },
        columnHeaders: {
          backgroundColor: '#03416a', // Darker header background for contrast
          color: '#000000', // Header text color
          fontWeight: 'bold', // Bold header font
          borderBottom: '2px solid #555', // Underline for headers
        },
        cell: {
          color: '#333', // Darker font for readability in cells
        },
        row: {
          '&:nth-of-type(odd)': {
            backgroundColor: '#f2f7fc', // Light gray-blue for alternate rows
          },
          '&:nth-of-type(even)': {
            backgroundColor: '#e6f0fb', // Slightly darker even rows
          },
          '&:hover': {
            backgroundColor: '#d2e8fc', // Row hover effect for better contrast
          },
        },
      },
    },
  },
});

const UserListView = (refetch) => {
  const token = localStorage.getItem("calendar_admin");
  const user_Id = localStorage.getItem("userId");
  const adminLvl = localStorage.getItem('admin_lvl');

  const [userList, setUserList] = useState([]);
  const [openSnackbar1, setOpenSnackbar1] = useState(false);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm")); // Detect if screen size is large

  // Define all columns
  const [columns] = useState([
    { field: 'name', headerName: 'Name', flex: 2 },
    { field: 'email', headerName: 'Email', flex: 3 },
    {
      field: 'referral_code', headerName: 'Referral Code', flex: 2,
      type: 'cumtom',
      renderCell: (params) => {
        return (
          <>
            {params.row.referral_code != '' && params.row.name == '' && (
              <IconButton color="primary" onClick={() => handleCopyToClipboard1(params.row.referral_code)}>
                <ContentCopyIcon sx={{ fontSize: '1rem' }} />
              </IconButton>)}
            <span>{params.row.referral_code}</span>
          </>
        );
      }
    },
    {
      field: 'admin', headerName: 'Admin', flex: 1, type: 'custom',
      renderCell: (params) => {
        return (
          <>
            {(params.row._id != user_Id && params.row.name !== '' && adminLvl > params.row.admin_lvl) ?
              (<Box display="flex" alignItems="center">
                <Switch checked={params.row.admin} onChange={() => {
                  setPro(params.row._id, 'admin', params.row.admin)
                }} />
              </Box>) :
              <Checkbox disabled checked={params.row.admin} />}
          </>
        );
      }
    },
    {
      field: 'admin_lvl', headerName: 'Admin lvl', flex: 1, type: 'custom',
      renderCell: (params) => {
        return (<>
          {
            (params.row._id != user_Id && params.row.name !== '' && adminLvl >= params.row.admin_lvl) ?
              <FormControl
                fullWidth
                sx={{
                  fontSize: '0.8rem', // Adjust font size
                  minWidth: 120, // Optional: Set a minimum width for compact design
                }}
                size="small" // Set the size to small
              >
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={params.row.admin_lvl}
                  onChange={(e) =>
                    setPro(params.row._id,
                      'admin_lvl',
                      e.target.value)} // Pass the onChange handler
                  sx={{
                    fontSize: '0.8rem', // Match font size for Select component
                  }}
                >
                  <MenuItem value={0}>{permission[0]}</MenuItem>
                  {adminLvl * 1 > 0 && <MenuItem value={1}>{permission[1]}</MenuItem>}
                  {adminLvl == 2 && <MenuItem value={2}>{permission[2]}</MenuItem>}
                </Select>
              </FormControl> :
              <span>
                {permission[params.row.admin_lvl]}
              </span>
          }
        </>
        );
      }
    },
    {
      field: 'block_flag', headerName: 'Blocked', flex: 1,
      type: 'custom',
      renderCell: (params) => {
        return (
          <>
            {(params.row._id != user_Id && params.row.name !== '' && adminLvl >= params.row.admin_lvl) ?
              (<Box display="flex" alignItems="center">
                <Switch checked={params.row.block_flag} onChange={() => {
                  setPro(params.row._id, 'block_flag', params.row.block_flag)
                }} />
              </Box>) :
              <Checkbox disabled checked={params.row.block_flag} />}
          </>
        );
      }
    },
    { field: 'invitedby', headerName: 'Invited By', flex: 1 },
    { field: '_id', headerName: 'ID', flex: 1 },
    { field: 'createdDate', headerName: 'Created Date', flex: 2 },
    { field: 'lastvisit', headerName: 'Last Visited', flex: 2 },
  ]);

  // Define column visibility model
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    name: true,
    email: true,
    admin: true,
    admin_lvl: false,
    block_flag: true,
    invitedby: false, // Invisible by default
    _id: false, // Invisible by default
    createdDate: false, // Invisible by default
    lastvisit: false, // Invisible by default
    referral_code: true, // Invisible by default
  });

  const setPro = async (id, flag, val) => {
    // let value = val;
    // switch (flag) {
    //   case 'block_flag':
    //     value = !val;
    //     break;
    //   case 'admin':
    //     break;
    //   default:
    //     break;
    // }
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/updateUserPropo/${id}/${flag}/${val}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data == 'ok') getUserList();

    } catch (error) {

    }
  }

  const getUserList = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/userlist`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const usersWithIds = response.data.map((user) => ({
        id: user._id, // Map the _id field to the id field required by DataGrid
        ...user,
      }));
      setUserList(usersWithIds);
    } catch (error) {
      console.error("Error fetching user list:", error.message);
    }
  };

  useEffect(() => {
    getUserList();
  }, [refetch]);

  const handleCopyToClipboard1 = (code) => {
    console.log(code);
    // if (code != '') 
      {
      navigator.clipboard.writeText(`${process.env.REACT_APP_API_BASE_URL}/signup?referralCode=${code}`);
      setOpenSnackbar1(true); // Show confirmation
    }
  };

  const handleCloseSnackbar1 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar1(false);
  };

  return (
    <ThemeProvider theme={modernDarkTheme}>
      <Box sx={{ minWidth: '300px', width: matches ? '80%' : '100%', padding: 2 }}>
        <Box sx={{ margin: '0 auto', height: '400px' }}>
          {userList.length > 0 ? (
            <DataGrid
              rows={userList}
              columns={columns}
              columnVisibilityModel={columnVisibilityModel} // Use visibility model
              onColumnVisibilityModelChange={(newModel) =>
                setColumnVisibilityModel(newModel)
              } // Allow toggling columns
              pageSize={10}
              rowsPerPageOptions={[5, 10, 20]}
              disableSelectionOnClick
            //   autoHeight={true} // Ensure auto height for dynamic content
            />
          ) : (
            <Typography>No users found.</Typography>
          )}
        </Box>
      </Box>
      {/* Snackbar for copy confirmation */}
      <Snackbar
        open={openSnackbar1}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar1}
        message="Copied to clipboard!"
        action={
          <IconButton size="small" color="inherit" onClick={handleCloseSnackbar1}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </ThemeProvider>
  );
};

export default UserListView;
